import type { SessionCapabilities } from '@/hooks/useSession';

export type NavItem = {
  to: string;
  label: string;
  icon: string;
  end?: boolean;
  /** 为真时需 capabilities[need] 才显示（如系统管理员专属） */
  need?: keyof SessionCapabilities;
};

export type NavSection = {
  id: string;
  label: string;
  items: NavItem[];
};

/**
 * 侧栏分组：自上而下按「新手常用路径」排列，减少找功能成本。
 * 路由 path 不变，仅调整分组与文案。
 */
export const APP_NAV_SECTIONS: NavSection[] = [
  {
    id: 'start',
    label: '入门与总览',
    items: [
      { to: '/dashboard', label: '工作台首页', icon: 'fa-solid fa-house', end: true },
      { to: '/help', label: '帮助与功能地图', icon: 'fa-solid fa-map', end: true },
    ],
  },
  {
    id: 'entries',
    label: '信息数据',
    items: [{ to: '/entries', label: '信息登记', icon: 'fa-solid fa-inbox', end: true }],
  },
  {
    id: 'site_content',
    label: '站点与展示',
    items: [
      { to: '/sites', label: '站点管理', icon: 'fa-solid fa-globe' },
      { to: '/site-masters', label: '站长管理', icon: 'fa-solid fa-user-tie' },
      { to: '/settings', label: '内容与样式', icon: 'fa-solid fa-pen-ruler' },
      { to: '/wechat', label: '微信公众号', icon: 'fa-brands fa-weixin' },
      { to: '/miniprograms', label: '小程序管理', icon: 'fa-solid fa-mobile-screen-button' },
      { to: '/promotion-areas', label: '微推广管理', icon: 'fa-solid fa-bullhorn' },
    ],
  },
  {
    id: 'robot',
    label: '推广与机器人',
    items: [
      { to: '/robot-management', label: '机器人管理', icon: 'fa-solid fa-robot', end: true },
    ],
  },
  {
    id: 'integration',
    label: '接入与自动化',
    items: [
      { to: '/interfaces', label: '接入与推送', icon: 'fa-solid fa-link', end: true },
      { to: '/ai-engines', label: 'AI 接口引擎', icon: 'fa-solid fa-wand-magic-sparkles', end: true },
      { to: '/wechat-official-push', label: '公众号推送', icon: 'fa-solid fa-paper-plane' },
      { to: '/oss', label: 'OSS 参数设置', icon: 'fa-solid fa-cloud-arrow-up' },
    ],
  },
  {
    id: 'ops',
    label: '日志与账号',
    items: [
      { to: '/log-center', label: '日志中心', icon: 'fa-solid fa-clock-rotate-left' },
      { to: '/login-logs', label: '系统登录日志', icon: 'fa-solid fa-fingerprint', need: 'manage_users' },
      { to: '/users', label: '用户管理', icon: 'fa-solid fa-users-gear', need: 'manage_users' },
      { to: '/system-config', label: '全局系统参数', icon: 'fa-solid fa-sliders', need: 'manage_users' },
    ],
  },
];
